import { Capacitor } from '@capacitor/core';
import { addDays, subDays } from 'date-fns';
import { ENV } from 'shared/ENV';
import { isProductionEnvironment } from 'shared/envUtils';
import {
  AppUpdate,
  AppUpdateAvailability,
} from '@capawesome/capacitor-app-update';

export const UPGRADE_LAST_SHOWN_KEY = 'UPGRADE_LAST_SHOWN';
const RECURRING_UPGRADE_MESSAGE_DAYS = 14;

const isUpgradeAvailable = async (): Promise<boolean> => {
  const updateInfo = await AppUpdate.getAppUpdateInfo();

  return (
    updateInfo.updateAvailability === AppUpdateAvailability.UPDATE_AVAILABLE
  );
};

const getLastUpgradeMessageTime = (): Date | null => {
  try {
    const upgradeTimeObj = JSON.parse(
      localStorage.getItem(UPGRADE_LAST_SHOWN_KEY) || '{}',
    );

    if (upgradeTimeObj.shown) {
      return new Date(upgradeTimeObj.shown);
    }

    return null;
  } catch (e) {
    return null;
  }
};

export const setMessageShownAt = (date: Date): void => {
  localStorage.setItem(UPGRADE_LAST_SHOWN_KEY, JSON.stringify({ shown: date }));
};

export const shouldShowUpgradeMessage = async (): Promise<boolean> => {
  if (ENV.VITE_SHOW_UPGRADE_MESSAGE) {
    return true;
  }

  if (!Capacitor.isNativePlatform()) {
    return false;
  }

  if (!isProductionEnvironment()) {
    return false;
  }

  const hasUpdate = await isUpgradeAvailable();

  if (!hasUpdate) {
    // reset counter for next time
    localStorage.removeItem(UPGRADE_LAST_SHOWN_KEY);
    return false;
  }

  const lastShownTime = getLastUpgradeMessageTime();
  const twoWeeksAgo = subDays(new Date(), RECURRING_UPGRADE_MESSAGE_DAYS);

  if (!lastShownTime) {
    // Give the user 3 days to upgrade before showing the first reminder
    setMessageShownAt(addDays(twoWeeksAgo, 3));
    return false;
  }

  return lastShownTime < twoWeeksAgo;
};
